module.exports = __webpack_public_path__ + "img/rectangle.68569992.png";